// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V1xhsvJgS8ciio {
  display: flex;
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  flex-direction: column;
  width: 100%;
  padding: 0 14px 14px;
  overflow: auto;
  transition: left 0.4s ease;
  background-color: var(--ds-background-input, #ffffff);
  gap: 14px;
}
.V1xhsvJgS8ciio h2 {
  margin-bottom: 0;
}
.V1xhsvJgS8ciio h2,
.V1xhsvJgS8ciio h3 {
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
}
.V1xhsvJgS8ciio p:last-child {
  margin-bottom: 0;
}
.V1xhsvJgS8ciio[data-offscreen='left'] {
  left: -100vw;
}
.V1xhsvJgS8ciio[data-offscreen='right'] {
  left: 100vw;
}
@media (prefers-reduced-motion: reduce) {
  .V1xhsvJgS8ciio {
    transition: none;
  }
}
.OVXSHbC4UvLGx8 {
  border-top: 1px solid var(--ds-border, #091e4224);
}
.OVXSHbC4UvLGx8 > * {
  display: flex;
  align-items: center;
  min-height: 70px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.qgvZKNij1sNffo {
  display: block;
}
.qgvZKNij1sNffo > * {
  /* stylelint-disable-next-line declaration-no-important */
  padding-left: 0 !important;
}
.FrboLxF7afenAo {
  padding: 24px;
  background-color: var(--ds-background-accent-purple-subtlest, rgba(234, 230, 255, 0.4));
}
.FrboLxF7afenAo p {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `V1xhsvJgS8ciio`,
	"tabList": `OVXSHbC4UvLGx8`,
	"navLinkContainer": `qgvZKNij1sNffo`,
	"secondary": `FrboLxF7afenAo`
};
export default ___CSS_LOADER_EXPORT___;
